import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import * as UI from 'ui'
import { Translation, Translator, useTranslation } from '@morningtrain/react-translations'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { MountSmartviewOnSelection } from '@morningtrain/react-smartviews'
import { ClearMissingSelectionOnExecute, Collection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { EnumFilter, SwitchFilter, PaginationFilter } from 'support/filters'
import CreateEmailTemplateSmartview from 'pages/app/emailtemplates/smartviews/CreateEmailTemplateSmartview'
import EditEmailTemplateSmartview from 'pages/app/emailtemplates/smartviews/EditEmailTemplateSmartview'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'

export default function EmailTemplatesIndexPage (props) {
  const slugFilterPlaceholder = useTranslation('email_templates.placeholders.filter_by_slug')

  return (
    <AdminPageWithSmartview withGlobalDepartmentFilter={false} slideInSmartview>
      <Translator namespace='email_templates'>
        <UI.PageHeader title={<TranslatedTitle name='titles.index' />}>
          <UI.ButtonWrap>
            <MountSmartviewOnClick smartview={<CreateEmailTemplateSmartview />} replace={false}>
              <UI.Button>
                <Translation name='actions.create' />
              </UI.Button>
            </MountSmartviewOnClick>
          </UI.ButtonWrap>
        </UI.PageHeader>

        <UI.Card>
          <Collection resourceName='email_templates'>
            <ClearMissingSelectionOnExecute />
            <MountSmartviewOnSelection smartview={<EditEmailTemplateSmartview />} replace={false} resetOnDeselect />
            <UI.TableHeader>
              <div className='flex space-x-4'>
                <EnumFilter
                  name='slug'
                  enum='email_template_slug'
                  placeholder={slugFilterPlaceholder}
                  className='w-40'
                  label={false}
                />
                <SwitchFilter
                  name='lang'
                  allowNull
                  enum='language'
                />
              </div>
            </UI.TableHeader>
            <Table className='cursor-pointer'>
              <Columns.Text
                name='subject'
                label={<Translation name='columns.subject.label' />}
              />
              <Columns.Enum
                name='slug'
                enum='email_template_slug'
                label={<Translation name='columns.type.label' />}
              />
              <Columns.Enum
                name='lang'
                enum='language'
                label={<Translation name='columns.lang.label' />}
              />
              <Columns.Text
                name='method'
                label={<Translation name='columns.method.label' />}
              />
              <Columns.Column alignment='right'>
                <UI.SquareButton color='lightgray'>
                  <UI.Icons.Settings />
                </UI.SquareButton>
              </Columns.Column>
            </Table>
            <PaginationFilter />
          </Collection>
        </UI.Card>
      </Translator>
    </AdminPageWithSmartview>
  )
}
